import NearBeSearch from './NearBeSearch'

export default NearBeSearch
